import React from 'react'
import { createTreeNode, getTreeNode, VehicleMilage, SelectDate, CancelationReason, ConfirmCancelation } from './components'

export default (dispatch, cancelPolicy) =>
  createTreeNode({
    display: {
      caption: 'When should the cancellation go into effect?',
      options: {
        odometerStatus: 'Cancel Now',
        selectPastDate: 'Cancel in past date',
        // selectFutureDate: 'Cancel in future date', // disabled
      },
    },
    children: {
      odometerStatus: createTreeNode({
        display: {
          caption: 'What is the odometer status right now?',
          options: {
            noOdometer: "I don't have it at all",
            uploadManually: 'I have the odometer picture - just let me upload it manually',
            sendLinkToUpload: 'I want the system to send the customer a link to upload it (within 5 days)',
            cancelWithoutOdometer: "Irrelevant - I want a flat cancel - don't charge this month at all",
            cancelWithoutCharge: "It's irrelevant - cancel only, with no charge/refund",
          },
        },
        children: {
          noOdometer: () => {
            dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'NoOdometer' })
            return createTreeNode({
              display: {
                caption: 'Should we charge a default?',
                options: {
                  chargeDefault: 'Charge default',
                  doNotChargeDefault: 'Do not charge default',
                },
              },
              children: {
                chargeDefault: () => {
                  dispatch({
                    type: 'SET_CANCELATION_ACTION',
                    payload: 'NoOdometer',
                  })
                  return createTreeNode({
                    display: {
                      caption: 'Cancelation reason',
                      component: CancelationReason,
                    },
                    validation: data => {
                      // make sure we have milage information for all vehicles in the policy
                      const validated = data.cancelationReason && data.cancelationText ? true : false
                      dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                      return validated
                    },
                    back: getTreeNode('odometerStatus.noOdometer'),
                    next: getTreeNode('confirmCancelation'),
                  })
                },
                doNotChargeDefault: () => {
                  dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'ManualOdometerUploadNoImage' })
                  return createTreeNode({
                    display: {
                      caption: 'Add Milage',
                      component: VehicleMilage,
                    },
                    children: {
                      cancelationReason: createTreeNode({
                        display: {
                          caption: 'Cancelation reason',
                          component: CancelationReason,
                        },
                        validation: data => {
                          // make sure we have milage information for all vehicles in the policy
                          const validated = data.cancelationReason && data.cancelationText ? true : false
                          dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                          return validated
                        },
                        back: getTreeNode(),
                        next: getTreeNode('confirmCancelation'),
                      }),
                    },
                    validation: data => {
                      // make sure we have milage information for all vehicles in the policy
                      const validated = data.vehicles.reduce((state, vehicle) => vehicle.id in data.odometerValues, false)
                      dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                      return validated
                    },
                    back: getTreeNode('odometerStatus.noOdometer'),
                    next: getTreeNode('cancelationReason'),
                  })
                },
              },
              back: getTreeNode('odometerStatus'),
            })
          },
          uploadManually: () => {
            dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'ManualOdometerUpload' })
            return createTreeNode({
              display: {
                caption: 'Upload images and provide milage information for each vehicle in the policy',
                component: () => <VehicleMilage uploadImage />,
              },
              validation: data => {
                // make sure we have milage information for all vehicles in the policy
                const validated = data.vehicles.reduce(
                  (state, vehicle) => vehicle.id in data.odometerValues && vehicle.id in data.odometerImages,
                  false
                )
                dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                return validated
              },
              next: getTreeNode('cancelationReason'),
              back: getTreeNode('odometerStatus'),
            })
          },
          sendLinkToUpload: () => {
            dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'Regular' })
            return createTreeNode({
              display: {
                caption: 'send link',
                component: () => (
                  <div>
                    <div>Are you sure you wish to send the customer the link for cancellation?</div>
                    <div>NOTE - if odometer won't be provided within 5 days, customer will be charged with default miles amount</div>
                  </div>
                ),
              },
              next: getTreeNode('cancelationReason'),
              back: getTreeNode('odometerStatus'),
            })
          },
          cancelWithoutOdometer: () => {
            dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'BackdatedFlat' })
            return createTreeNode({
              display: {
                caption: 'Cancel without odometer information',
                component: () => (
                  <div>
                    <p>Are you sure?</p>
                    <p>Flat cancel should be used only within 1-2 days since the last charge.</p>
                    <p>Customer will not be charged for this month at all</p>
                  </div>
                ),
              },
              children: {
                cancelationReason: createTreeNode({
                  display: {
                    caption: 'Cancelation reason',
                    component: CancelationReason,
                  },
                  validation: data => {
                    // make sure we have milage information for all vehicles in the policy
                    const validated = data.cancelationReason && data.cancelationText ? true : false
                    dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                    return validated
                  },
                  next: getTreeNode('confirmCancelation'),
                }),
              },
              next: getTreeNode('odometerStatus.cancelWithoutOdometer.cancelationReason'),
              back: getTreeNode('odometerStatus'),
            })
          },
          cancelWithoutCharge: () => {
            dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'FreeOfCharge' })
            return createTreeNode({
              display: {
                caption: 'Cancel without odometer information',
                component: () => <div>Are you sure you wish to cancel the policy without any additional charge/refund?'</div>,
              },
              next: getTreeNode('cancelationReason'),
              back: getTreeNode('odometerStatus'),
            })
          },
        },
        back: getTreeNode(),
      }),
      selectPastDate: createTreeNode({
        display: {
          caption: 'Select date for policy cancelation',
          component: () => <SelectDate />,
        },
        children: {
          odometerStatus: createTreeNode({
            display: {
              caption: 'What is the odometer status ?',
              options: {
                noOdometer: "I don't have it at all",
                uploadManually: 'I have the odometer picture - just let me upload it manually',
                sendLinkToUpload: 'I want the system to send the customer a link to upload it (within 5 days)',
                cancelWithoutCharge: "It's irrelevant - cancel only, with no charge/refund",
              },
            },
            children: {
              noOdometer: () => {
                dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'NoOdometer' })
                return createTreeNode({
                  display: {
                    caption: 'Should we charge a default?',
                    options: {
                      chargeDefault: 'Charge default',
                      doNotChargeDefault: 'Do not charge default',
                    },
                  },
                  children: {
                    chargeDefault: Tree => {
                      return getTreeNode('cancelationReason')(Tree)
                    },
                    doNotChargeDefault: () => {
                      dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'ManualOdometerUploadNoImage' })
                      return createTreeNode({
                        display: {
                          caption: 'Add Milage',
                          component: VehicleMilage,
                        },
                        validation: data => {
                          // make sure we have milage information for all vehicles in the policy
                          const validated = data.vehicles.reduce((state, vehicle) => vehicle.id in data.odometerValues, false)
                          dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                          return validated
                        },
                        next: getTreeNode('cancelationReason'),
                      })
                    },
                  },
                  back: getTreeNode('selectPastDate.odometerStatus'),
                })
              },
              uploadManually: () => {
                dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'ManualOdometerUpload' })
                return createTreeNode({
                  display: {
                    caption: 'Upload Images',
                    component: () => <VehicleMilage uploadImage />,
                  },
                  validation: data => {
                    // make sure we have milage information for all vehicles in the policy
                    const validated = data.vehicles.reduce(
                      (state, vehicle) => vehicle.id in data.odometerValues && vehicle.id in data.odometerImages,
                      false
                    )
                    dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
                    return validated
                  },
                  next: getTreeNode('cancelationReason'),
                  back: getTreeNode('selectPastDate.odometerStatus'),
                })
              },
              sendLinkToUpload: () => {
                dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'Regular' })
                return createTreeNode({
                  display: {
                    caption: 'Send odometer upload link',
                    component: () => (
                      <div>
                        <div>Are you sure you wish to send the customer the link for cancellation?</div>
                        <div>NOTE - if odometer won't be provided within 5 days, customer will be charged with default miles amount</div>
                      </div>
                    ),
                  },
                  next: getTreeNode('cancelationReason'),
                  back: getTreeNode('selectPastDate.odometerStatus'),
                })
              },
              cancelWithoutCharge: () => {
                dispatch({ type: 'SET_CANCELATION_ACTION', payload: 'FreeOfCharge' })
                return createTreeNode({
                  display: {
                    caption: 'Cancel without odometer information',
                    component: () => <div>Are you sure you wish to cancel the policy without any additional charge/refund?'</div>,
                  },
                  next: getTreeNode('cancelationReason'),
                  back: getTreeNode('selectPastDate.odometerStatus'),
                })
              },
            },
            back: getTreeNode('selectPastDate'),
          }),
        },
        back: getTreeNode(),
        next: getTreeNode('selectPastDate.odometerStatus'),
      }),
      cancelationReason: createTreeNode({
        display: {
          caption: 'Cancelation reason',
          component: CancelationReason,
        },
        validation: data => {
          // make sure we have milage information for all vehicles in the policy
          const validated = data.cancelationReason && data.cancelationText ? true : false
          dispatch({ type: 'SET_VALIDATION_STATUS', payload: !validated })
          return validated
        },
        next: getTreeNode('confirmCancelation'),
      }),
      confirmCancelation: createTreeNode({
        display: {
          caption: 'Confirm cancellation',
          component: ConfirmCancelation,
          nextCaption: 'Cancel Policy',
        },
        next: async tree => {
          try {
            const res = await cancelPolicy()
            if (res.status !== 200) throw new Error('Failed to cancel policy')
            return getTreeNode('cancelationComplete')(tree)
          } catch (error) {
            return getTreeNode('cancelationError')(tree)
          }
        },
      }),
      cancelationComplete: createTreeNode({
        display: {
          caption: 'Cancelation Success',
          component: () => (
            <div
              style={{
                minHeight: '12rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Cancelation Complete
            </div>
          ),
          nextCaption: 'Done',
        },
        last: true,
      }),
      cancelationError: createTreeNode({
        display: {
          caption: 'Cancelation Failed',
        },
      }),
    },
  })
